var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.value,"headline":"Activate Role","htmlInfo":_vm.info,"actionLabel":"Activate","data-testid":"activate-role-popup","icon":"org_icon_role","applyBorderClass":true},on:{"input":function($event){return _vm.$emit('input', $event)},"onAction":function($event){return _vm.$emit('onSave')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }